import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Table } from '../../../../../common/table'
import { Panel } from '../../../../common/panel'
import {
  selectDataTableAddCompany,
  selectIdsTableAddCompany,
  selectListCompanyImport,
} from '../../store/slice'
import { ConfirmClearAll } from './ConfirmClearAll'
import { getSchemaTableAddCompany } from './schemaTableAddCompany'

export const ListCompany = ({ setDisplay }) => {
  const list = useSelector(selectListCompanyImport)
  const ids = useSelector(selectIdsTableAddCompany)

  const [isShowConfirmClearAll, setShowConfirmClearAll] = useState(false)

  const clearAll = () => {
    return (
      <Element
        elementName="p"
        style={{ color: '#2C73E8' }}
        onClick={() => {
          setShowConfirmClearAll(true)
          setDisplay(false)
        }}
      >
        <Translate value="library.filterCompanies.CLEAR_ALL" />
      </Element>
    )
  }
  if (!list.length) return <></>

  return (
    <>
      <Panel
        label={
          <Translate
            value="library.detailsPortfolios.COMPANIES_LIST"
            count={ids.length || 0}
          />
        }
        isRightHeader
        renderRightHeader={() => <>{!!ids.length && clearAll()}</>}
        style={{ margin: 0, marginTop: 5 }}
        styleContent={{ padding: 0 }}
        isScroll={false}
      >
        <Table
          key={ids.length}
          ids={ids}
          getDataFromRedux={selectDataTableAddCompany}
          schema={getSchemaTableAddCompany()}
          isNoDataWithHead
          autoHeightMax={600}
        />
      </Panel>
      <ConfirmClearAll
        setShowPopupAddCompany={setDisplay}
        isShow={isShowConfirmClearAll}
        setShow={setShowConfirmClearAll}
      />
    </>
  )
}
